module.exports = __webpack_public_path__ + "img/rml-logo.d7e41219.png";